export default __webpack_public_path__ + "static/N0171-cc26edaac5f8830a127339aa2a8ef2fe.png";